import { Skeleton } from '@sunwebgroup/uds-ui/skeleton'
import styles from './ProductAdLoading.module.css'

export function ProductAdLoading() {
  return (
    <div className={styles.wrapper}>
      <Skeleton className={styles.productImage} />
      <div className={styles.footer}>
        <Skeleton className={styles.heading} />
        <Skeleton className={styles.subHeading} />
      </div>
    </div>
  )
}
